<template>
    <div class="pt5 pb5 flex aic">
        <div class="icon"></div>
        <div class="ml10 fontPFM fs18">{{title}}</div>
    </div>
</template>

<script>
    export default {
        name: "hos-apply-title",
        props:{
            title:{
                type:String,
                default:""
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/hos";
</style>